export class Currency {
  id: number;
  name: string;
  code: string;
  country: string;
}
